import List from "./List.js";
import Create from "./Create.js";
import Show from "./Show.js";

export default { List, Create, Show };
